<template>
    <div class="allwidth">
        <!-- <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.auto.learning" target="_blank"> -->
        <a href="https://m.auto-learning.com/mstatic/download/lushangdushu.apk" target="_blank">
        <img src="../assets/downloadapp.jpg" width="100%"/>
        </a>
    </div>

</template>
<script>
export default {
    
    metaInfo() {
        return{
        title: '路上畅听APP下载' + this.$store.state.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
}
</script>
<style scoped>

.allwidth{padding: 0; margin: 0;overflow: hidden;}
    img{float: left;}
</style> 